import logo from "../assets/images/icon_512.png";

export default function SplashScreen(props: { animating: boolean }) {
  return (
    <div className="relative flex flex-col h-[100svh] justify-end items-center">
      <div
        className={`absolute ${props.animating ? "~w-12/16 ~mt-4/5.5 ~ml-3.5/5 ~pr-1.5/2 transition-all duration-1000 ease-in-out top-0 left-0 bottom-auto right-auto m-auto" : "md:w-1/7 w-1/5 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"}`}
      >
        <img
          src={logo}
          className={
            props.animating
              ? "animate-out duration-1000"
              : "animate-bounce duration-1000"
          }
          alt="logo"
        />
      </div>
      <p className="absolute top-1/2 ~mt-16/44 text-silver font-archb ~text-base/xl">
        Play for the prize, stay for the cause.
      </p>
    </div>
  );
}
